import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  RlaGuards,
  RouteLinkAction,
} from '../../../../types/route-link-action';

@Component({
    selector: 'lui-footer-main',
    templateUrl: './footer-main.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterMainComponent {
  @Input() links!: RouteLinkAction[] | null | undefined;
  @Input() copyright!: string;

  date = new Date();

  isRoute = RlaGuards.isRoute;

  isLink = RlaGuards.isLink;

  isAction = RlaGuards.isAction;
}
